<styles-smart-table
  #smartTable
  [datasource]="projects.items"
  [showImageCell]="false"
  [expandable]="expandable"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [expandedColumns]="['details']"
  [showColumnHeaders]="showColumnHeaders"
  matSort
  (matSortChange)="updateSort($event)"
  [matSortActive]="buildSort()?.active"
  [matSortDirection]="buildSort()?.direction"
>
  <ng-container matColumnDef="type">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div style="position: relative; top: 5px">{{$any(element)?.type }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="image"></th>
    <td
      mat-cell
      *matCellDef="let element"
      [attr.rowspan]="smartTable.getImageRows(element)"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="image"
    >
      <framework-assets-image
        image
        [assetSet]="$any(element)?.defaultAsset"
        [size]="130"
        [style.height.px]="smartTable.isExpanded(element) ? 124 : 44"
        [routerLink]="element | findRoute"
      >
      </framework-assets-image>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="date"
      mat-sort-header
    >
      Date
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="date"
    >
      <styles-icon-value-caption
        caption="Due date"
        icon="date_range"
        *ngIf="element.status.id !== 'Completed'; else completed"
      >
        {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      <ng-template #completed>
        <styles-icon-value-caption caption="Completion date" icon="date_range">
          {{ $any(element)?.projectEndDate || $any(element)?.dueDate | date : 'mediumDate' }}
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let element" [attr.colspan]="8">
      <div class="details-flex-wrapper">
        <framework-clusted-profile-images [userList]="$any(element)?.members" [numberToShow]="10">
        </framework-clusted-profile-images>

        <framework-access-level-chip
          [accessLevel]="{id:'Private', name:'Private'}"
          suffix="Project"
          *ngIf="$any(element)?.module === 'InternalProject' || $any(element)?.module === 'AccountManagement'; else publicProject"
        >
        </framework-access-level-chip>
        <ng-template #publicProject>
          <framework-access-level-chip [accessLevel]="{id:'Public', name:'Public'}" suffix="Project">
          </framework-access-level-chip>
        </ng-template>

        <framework-tag-chip *ngFor="let tag of $any(element).tags" [tag]="tag"> </framework-tag-chip>

        <styles-icon-value-caption caption="Campaign" icon="campaign" *ngIf="$any(element)?.campaign">
          {{ $any(element).campaign.name }}
        </styles-icon-value-caption>

        <styles-icon-value-caption caption="Start Date" icon="date_range">
          {{ $any(element)?.projectStartDate | date : 'mediumDate' }}
        </styles-icon-value-caption>

        <styles-icon-value-caption
          caption="Template"
          icon="backup_table"
          *ngIf="$any(element)?.productInstance?.productDefinitionName"
        >
          {{ $any(element).productInstance?.productDefinitionName }}
        </styles-icon-value-caption>

        <styles-icon-value-caption
          caption="SOW"
          icon="receipt"
          *ngIf="$any(element)?.parent.type === 'StatementOfWork'"
        >
          {{ $any(element).parent.name }}
        </styles-icon-value-caption>

        <styles-icon-value-caption
          caption="SOW"
          icon="receipt"
          *ngIf="$any(element)?.parent?.parent?.type === 'StatementOfWork'"
        >
          {{ $any(element).parent.parent.name }}
        </styles-icon-value-caption>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th
      mat-header-cell
      *matHeaderCellDef
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
      mat-sort-header
    >
      Organization
    </th>
    <td
      mat-cell
      *matCellDef="let element"
      class="mid-column"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="organization"
    >
      <styles-icon-value-caption caption="Organization" icon="corporate_fare" *ngIf="element.feedDetails">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="default"
      mat-sort-header
    >
      Name
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div class="title ellipsis-text" [matTooltip]="$any(element)?.name">
          <ng-container *ngIf="showOrgInTitle === true">
            <span class="organization">
              {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}</span
            >&nbsp;&nbsp;&nbsp;<span class="carat">›</span>&nbsp;&nbsp;
          </ng-container>
          <span
            *ngIf="!(element | hasMaster) && element?.parent?.module !== 'Contract' && $any(element)?.parent?.parent?.module !== 'Contract'"
          >
            {{ (element!.parent | findSpace)?.name }} ›
          </span>
          {{$any(element)?.name }}
        </div>

        <framework-master-project-progress-line
          [masterProject]="element"
          [rounding]="true"
          [stroke]="6"
          [gap]="3"
          *ngIf="(element | workInType : 'MasterProject') && (element | masterSpaceTaskCount); else nativeProduction"
        >
        </framework-master-project-progress-line>

        <ng-template #nativeProduction>
          <framework-space-progress-line [space]="element" [rounding]="true" [stroke]="6">
          </framework-space-progress-line>
        </ng-template>
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th
      mat-header-cell
      *matHeaderCellDef
      [sharedListingColumnWidth]="columnBuilder"
      columnName="status"
      mat-sort-header
    >
      Status
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip [workStatus]="$any(element)?.status"></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner" mat-sort-header>
      Owner
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="contentType">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      Content Type
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="contentType">
      <styles-icon-value-caption
        caption="Content Type"
        icon="category"
        *ngIf="($any(element)?.productType || ($any(element)?.productTypes && $any(element).productTypes!.length > 0)); else noContentType"
        [matTooltip]="$any(element).productType?.name + ' - ' + $any(element)?.productInstance?.variant"
      >
        <ng-container *ngIf="$any(element)?.productTypes; else singleType">
          <ng-container *ngFor="let type of $any(element)?.productTypes; last as isLast">
            {{ type.name }} <ng-container *ngIf="!isLast">&nbsp;•&nbsp;</ng-container>
          </ng-container>
        </ng-container>
        <ng-template #singleType>
          {{ $any(element).productType.name }}<ng-container *ngIf="$any(element)?.productInstance?.variant"
            >&nbsp;•&nbsp;{{ $any(element)?.productInstance?.variant }}</ng-container
          ></ng-template
        >
      </styles-icon-value-caption>
      <ng-template #noContentType>
        <styles-icon-value-caption
          caption="Product Type"
          icon="category"
          *ngIf="element.productInstance"
          [matTooltip]="$any(element)?.productInstance.name + ' - ' + $any(element)?.productInstance?.variant"
        >
          {{ $any(element)?.productInstance.name }}<ng-container *ngIf="$any(element)?.productInstance?.variant"
            >&nbsp;•&nbsp;{{ $any(element)?.productInstance.variant }}</ng-container
          >
        </styles-icon-value-caption>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="units">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="units">Units</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="units">
      <div class="task-box">
        <shared-unit-value-icon
          [element]="element"
          *ngIf="element?.units?.totalUnits || 0 > 0; else noUnits"
          [isCore]="element.units?.currency && element.units.currency.id === 'CoreSmb'"
        >
          {{ element.units?.completedUnits ?? 0 | number : '1.0-2' }} / {{ element.units?.totalUnits | number : '1.0-2'
          }}
        </shared-unit-value-icon>
        <ng-template #noUnits> - </ng-template>
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="actions"></th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="actions">
      <framework-action-button [task]="element" [iconSize]="18" *ngIf="element.defaultAction">
      </framework-action-button>
      <shared-listing-action-dropdown
        menu
        *ngIf="($any(element)?.actions)!.length > 0"
        [level]="element.module === 'MasterProject' ? 'master' : 'project'"
        [location]="element | moduleTypePipe"
        [masterProject]="element | findMaster"
        [project]="element | findSpace"
        [phase]="element | phasePipe"
        [task]="element"
        [actions]="$any(element)?.actions"
      >
      </shared-listing-action-dropdown>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-owner">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-person-image [person]="group.group" size="30px"></framework-person-image>
        {{ group.group.name }}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-date">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper"><mat-icon>calendar_today</mat-icon> {{group.group | date : 'MMMM y'}}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-organization">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <mat-icon>corporate_fare</mat-icon>
        {{ group.group.organizationName || group.group.feedName}}
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="group-status">
    <td colspan="999" mat-cell *matCellDef="let group">
      <div class="wrapper">
        <framework-work-status-chip [workStatus]="group.group"></framework-work-status-chip>
      </div>
    </td>
  </ng-container>
</styles-smart-table>
